module.exports = __webpack_public_path__ + "assets/img/bjimg1.924e83eb.png";